// src/utils/constants.js

// 카카오 애드핏 광고단위 (adfit.kakao.com > 광고관리에서 발급, 비우면 광고 영역 미렌더링)
// StickyAd(상시 고정 배너)에서만 사용:
// - banner: 모바일/기본 하단 고정 320x100
// - sideLeft/sideRight: 데스크톱 좌·우 고정 레일 160x600 (단위 발급 후 unit 입력 시 활성화)
export const ADFIT_UNITS = {
  banner: { unit: "DAN-nAWMnKqYuXEppEqO", width: 320, height: 100 },
  sideLeft: { unit: "DAN-gbnnV5L1qy0lY7Fp", width: 160, height: 600 },
  sideRight: { unit: "DAN-atz3rPlIXEZwXcSu", width: 160, height: 600 },
};

// 후원(커피 사주기) 링크 — 토스 아이디 송금(https://toss.me/아이디) 또는 카카오페이 송금코드 링크
// 비워두면 편지 결과 화면의 후원 버튼이 렌더링되지 않음
export const SUPPORT_URL = "";

export const ANIMALS = [
  { e: "🐶", l: "강아지" },
  { e: "🐱", l: "고양이" },
  { e: "🐹", l: "햄스터" },
  { e: "🐰", l: "토끼" },
  { e: "🐦", l: "새" },
  { e: "🐠", l: "물고기" },
  { e: "🐢", l: "거북이" },
  { e: "✏️", l: "기타" },
];

export const ANIMAL_EMOJIS = {
  강아지: "🐶",
  고양이: "🐱",
  햄스터: "🐹",
  토끼: "🐰",
  새: "🐦",
  물고기: "🐠",
  거북이: "🐢",
  기타: "🐾",
};

export const PERSONALITIES = [
  "애교쟁이",
  "도도함",
  "겁쟁이",
  "용감함",
  "먹보",
  "질투쟁이",
  "자기 세계가 있음",
  "붙어있는 걸 좋아함",
  "혼자 있는 걸 좋아함",
  "장난꾸러기",
  "조용함",
  "눈치가 빠름",
  "고집이 셈",
  "온순함",
  "에너지가 넘침",
  "낯을 가림",
];

export const NICKNAMES = [
  "오빠",
  "언니",
  "엄마",
  "아빠",
  "누나",
  "형",
  "이름으로",
  "직접입력",
];

export const PAPERS = [
  { id: "p1", lp: "lp1", e: "🌸", n: "봄 꽃잎" },
  { id: "p2", lp: "lp2", e: "🌊", n: "파란 하늘" },
  { id: "p3", lp: "lp3", e: "🍂", n: "크래프트지" },
  { id: "p4", lp: "lp4", e: "🌙", n: "수채화 구름" },
  { id: "p5", lp: "lp5", e: "🍃", n: "초록 정원" },
  { id: "p6", lp: "lp6", e: "⭐", n: "밤하늘" },
];

export const PERIODS = ["얼마 안 됐어요", "1년 이내", "오래 전이에요"];
export const GENDERS = ["남자", "여자", "선택 안 함"];
